import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { trackByIndex } from '@y42/angular/util';
import { ColumnTypeEnum, OperatorEnum } from '@y42/json-schema';
import { SelectOption } from '@y42/util/select-option';
import { OperationInputFormService } from '../../operation-input-form.service';

@Component({
  selector: 'y42-operation-input-text[columnType]',
  templateUrl: './operation-input-text.component.html',
  styleUrls: ['../operation-input-shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationInputTextComponent {
  constructor(private readonly formService: OperationInputFormService) {}

  readonly trackByIndex = trackByIndex<unknown>;

  @Input()
  columnType!: ColumnTypeEnum;

  @Input() predefinedValues: string[] | null = null;
  @Input() enableMoreConditions = false;

  @Output()
  loadAutoProposal: EventEmitter<void> = new EventEmitter();

  @Input()
  operatorOptions?: Array<SelectOption<OperatorEnum>>;

  readonly operationsFormArray = this.formService.operationsFormArray;
}
